import React from "react";
import { Card, CardBody, CardTitle } from "reactstrap";

export default function OdometerSection({
	startValue,
	endValue
}: {
	startValue: number | null;
	endValue: number | null;
}) {
	return (
		<Card className="mt-3">
			<CardBody>
				<CardTitle
					tag="h5"
					style={{
						display: "flex",
						flexDirection: "row",
						justifyContent: "space-between"
					}}
				>
					<span>Odometer</span>
				</CardTitle>
				<div
					style={{
						display: "flex",
						flexDirection: "column"
					}}
				>
					<div
						style={{
							display: "flex",
							flexDirection: "row",
							gap: "1rem",
							justifyContent: "space-between"
						}}
					>
						<p className="text-sm">Odometer Awal:</p>
						<p className="text-sm"> {startValue || 0}</p>
					</div>
					<div
						style={{
							display: "flex",
							flexDirection: "row",
							gap: "1rem",
							justifyContent: "space-between"
						}}
					>
						<p className="text-sm">Odometer Akhir:</p>
						<p className="text-sm"> {endValue || 0}</p>
					</div>
					<div
						style={{
							display: "flex",
							flexDirection: "row",
							gap: "1rem",
							justifyContent: "space-between"
						}}
					>
						<p className="text-sm">Jarak Tempuh</p>
						<p className="text-sm">
							{startValue && endValue ? endValue - startValue : 0}
						</p>
					</div>
				</div>
			</CardBody>
		</Card>
	);
}
